import { render, staticRenderFns } from "./SuspensionModal.vue?vue&type=template&id=3d6274aa&scoped=true"
import script from "./SuspensionModal.vue?vue&type=script&lang=ts"
export * from "./SuspensionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6274aa",
  null
  
)

export default component.exports